import { fetchBackend } from "./auth";

export class Booking {

    startDate: Date;
    endDate: Date;
    description?: string;
    title: string;
    week: number;

    constructor( start: Date, end:Date, title: string, desc?: string) {
        this.startDate = start;
        this.endDate = end;
        this.week = getWeekNumber( start );
        this.title = title;
        this.description = desc;
    }

}

let bookings:Booking[] = [];

export const freeWeeks: number[] = [
    8, 9, 11, 12
]

export function isStartDate( date: Date ) : boolean {
    return bookings.some( (booking) => booking.startDate.toDateString() === date.toDateString() );
}

export function isEndDate( date: Date ) : boolean {
    return bookings.some( (booking) => booking.endDate.toDateString() === date.toDateString() );
}

export function isBooked(date: Date): boolean {
    return bookings.some((booking) => date >= booking.startDate && date <= booking.endDate);
}

function getDatesBetween(startDate: Date, endDate: Date): Date[] {
    const dates: Date[] = [];
    const currentDate = new Date(startDate.getDate() + 1);

    while (currentDate < endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
}


export function hasOverlap( booking: Booking): Booking | null{
    const dates = getDatesBetween(booking.startDate, booking.endDate);
    const bookedDates = dates.filter((date)=>isBooked(date));
    if( bookedDates.length === 0 ){
        return null;
    } else {
        return getBooking(bookedDates[0]);
    }
}

export function getBooking(date: Date): Booking | null {
    for (let booking of bookings) {
        if (date >= booking.startDate && date <= booking.endDate) {
            return booking;
        }
    }
    return null;
}

export function getStartDate( date : Date ): Date {
    const dayOfWeek = date.getDay();
    const daysSinceSaturday = (dayOfWeek) % 7;
    const startDate = new Date(date);
    startDate.setDate(date.getDate() - daysSinceSaturday);
    return startDate;
}

export function getStartDateForWeek(week: number): Date {
    const currentYear = new Date().getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1);
    const firstSaturday = getStartDate(firstDayOfYear);

    const startDate = new Date(firstSaturday);
    startDate.setDate(firstSaturday.getDate() + (week -1) * 7);

    return startDate;
}

export function getEndDate( date : Date ): Date {
    const dayOfWeek = date.getDay();
    const daysUntilNextSaturday = (6 - dayOfWeek + 7) % 7 || 7;
    const endDate = new Date(date);
    endDate.setDate(date.getDate() + daysUntilNextSaturday);
    return endDate;
}

export function getEndDateForWeek( week : number ): Date{
    const firstSaturday = getStartDateForWeek( week );
    const endDate = new Date( firstSaturday );
    endDate.setDate( endDate.getDate() + 7 );
    return endDate;
}

export function getWeekNumber(date: Date): number {
    const tempDate = new Date(date.getTime());
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
    const yearStart = new Date(tempDate.getFullYear(), 0, 1);
    let weekNumber = Math.ceil((((tempDate as any) - (yearStart as any)) / 86400000 + 1) / 7);
    if( date.getDay() >= 5 ){
        weekNumber += 1;
    }
    return weekNumber;
}

function pushNewBooking( booking: Booking ){

    const endDate = booking.endDate
    endDate.setDate( endDate.getDate() + 1 );

    const obj = {
        summary: booking.title,
        description: booking.description,
        start: { date: booking.startDate.toISOString().split('T')[0] },
        end: { date: endDate.toISOString().split("T")[0]}
    }

    fetchBackend("/api/events", {method: 'POST', body: JSON.stringify(obj)}).then((res)=>{
        if( res?.status !== 201 ){
            console.log( res );
            throw( new Error("Ongelma tallennuksessa yritä myöhemmin uudelleen tai soita jussille"))
        }
    });

}

export function removeBooking( booking:Booking ){

    // Remove from front.
    bookings = bookings.filter(
        ( item ) => {
            return !( item.title === booking.title && item.startDate === booking.startDate );
        }
    )

    // TODO: Remove from backend.
}

export function setNewBooking( booking: Booking, shouldSave=false ){

    if( shouldSave ){
        pushNewBooking( booking );
    }
    bookings.push( booking );
}

export async function fetchBookings(){

    try{
        const year = new Date().getFullYear();

        const resps = await Promise.all([ 
            fetchBackend(`/api/events/${year - 1}`, {method: "get"}),
            fetchBackend(`/api/events/${year}`, {method: "get"}),
            fetchBackend(`/api/events/${year + 1}`, {method: "get"})
        ])
        resps.forEach( async (resp) =>{
            const json = await resp.json();
            json?.forEach(( item:any )=>{
                const endDate = new Date(item.end.date);
                endDate.setDate( endDate.getDate() -1);
                const booking = new Booking(
                    new Date( item.start.date ),
                    endDate,
                    item.summary,
                    item.description
                );
        
                setNewBooking( booking );
            });
        });
    } catch (err){
        console.log(err);
    }
}

export function fetchFreeWeeks(){
    //TODO: Implement.
}
